import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import BackdropLoadingScreen from "../../common/BackdropLoadingScreen";
import { NavBar } from "../../common/NavBar";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../common/SearchBar";
import { theme } from "../../utils/themeCreator";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AddTalkDownMessageWizard } from "./AddTalkDownMessageWizard";
import { TalkDownMessageDetail } from "./TalkDownMessageDetail";
import { TalkDownMessagesTable } from "./TalkDownMessagesTable";
import { useTalkDownMessagesStore } from "./talkDownMessagesStore";
import { TalkDownMessage } from "./talkDownMessageTypes";

export const TalkDownMessages = ({
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const messages = useTalkDownMessagesStore((s) => s.messages);
  const loadMessages = useTalkDownMessagesStore((s) => s.loadMessages);
  const loading = useTalkDownMessagesStore((s) => s.loading);
  const loadError = useTalkDownMessagesStore((s) => s.loadError);
  const [searchInput, setSearchInput] = React.useState("");
  const [appliedSearch, setAppliedSearch] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [addOpen, setAddOpen] = React.useState(false);
  const [selected, setSelected] = React.useState<TalkDownMessage | null>(null);

  React.useEffect(() => {
    void loadMessages();
  }, [loadMessages]);

  const filtered = React.useMemo(() => {
    const q = appliedSearch.trim().toLowerCase();
    if (!q) return messages;
    return messages.filter(
      (m) =>
        m.name.toLowerCase().includes(q) ||
        m.groupName.toLowerCase().includes(q) ||
        m.recordedBy.toLowerCase().includes(q)
    );
  }, [messages, appliedSearch]);

  React.useEffect(() => {
    setPage(0);
  }, [appliedSearch]);

  return (
    <div>
      <BackdropLoadingScreen openState={loading} />
      <div className="absolute h-screen w-screen bg-actuate-grey">
        <div
          className={
            !navBarCollapsed
              ? "absolute top-[60px] left-[150px] right-[1px] h-[19px]] bg-white"
              : "absolute top-[60px] left-[75px] right-[1px] h-[19px]] bg-white"
          }
        >
          <p className="indent-6 p-3 font-mulish text-[20px] font-black">
            Talk Down Messages
          </p>
          <div className="absolute top-[7px] right-[30px]">
            <ThemeProvider theme={theme}>
              <Button
                type="button"
                color="primary"
                onClick={() => setAddOpen(true)}
              >
                + ADD MESSAGE
              </Button>
            </ThemeProvider>
          </div>
        </div>

        <div
          className={
            !navBarCollapsed
              ? "absolute left-[135px] top-[10px]"
              : "absolute left-[60px] top-[10px]"
          }
        >
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              value={searchInput}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setSearchInput(event.target.value)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") setAppliedSearch(searchInput);
              }}
              inputProps={{ "aria-label": "search talk down messages" }}
            />
          </Search>
        </div>
        <div
          className={
            !navBarCollapsed
              ? "absolute left-[500px] top-[10px]"
              : "absolute left-[425px] top-[10px]"
          }
        >
          <button
            type="button"
            className="h-[39px] w-[120px] rounded bg-actuate-orange font-mulish text-[16px] text-white shadow-button"
            onClick={() => setAppliedSearch(searchInput)}
          >
            Search
          </button>
        </div>

        <div
          className={
            !navBarCollapsed
              ? "absolute left-[150px] top-[130px]"
              : "absolute left-[75px] top-[130px]"
          }
        >
          {loadError && (
            <p className="mb-3 font-mulish text-[13px] text-[#B3261E]">
              {loadError}
            </p>
          )}
          <TalkDownMessagesTable
            rows={filtered}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            onOpenDetail={setSelected}
          />
        </div>
      </div>

      <AddTalkDownMessageWizard
        open={addOpen}
        onClose={() => setAddOpen(false)}
      />
      <TalkDownMessageDetail
        message={selected}
        onClose={() => setSelected(null)}
      />

      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
